import { Injectable, ViewContainerRef, ViewRef } from '@angular/core';

@Injectable()
export class ViewContainerMappingService {
  private containers = new Map<string, ViewContainerRef>();
  private views = new Map<string, ViewRef>();
  private viewToContainerMapping = new Map<string, string>();

  addContainer(containerId: string, container: ViewContainerRef) {
    this.containers.set(containerId, container);
  }

  addView(viewId: string, view: ViewRef) {
    this.views.set(viewId, view);
  }

  switchOutputViewToThumbnail(outputName: string) {
    this.updateViewContainerMapping(
      outputName,
      this.buildThumbnailContainerId(outputName),
    );
  }

  switchOutputViewToMainCanvas(outputName: string) {
    this.updateViewContainerMapping(
      outputName,
      this.buildMainContainerId(outputName),
    );
  }

  switchOutputViewToSplitView(
    outputName: string,
    splitViewContainerId: string,
  ) {
    this.updateViewContainerMapping(outputName, splitViewContainerId);
  }

  updateViewContainerMapping(viewId: string, targetContainerId: string) {
    const view = this.views.get(viewId);
    if (!view) {
      return;
    }

    const currentContainerId = this.viewToContainerMapping.get(viewId);
    if (currentContainerId === targetContainerId) {
      return;
    }
    if (currentContainerId) {
      this.containers.get(currentContainerId)?.detach();
    }
    this.containers.get(targetContainerId)?.detach();
    this.containers.get(targetContainerId)?.insert(view);
    this.viewToContainerMapping.set(viewId, targetContainerId);
  }

  cleanUp(containerId: string, viewId?: string) {
    this.containers.delete(containerId);
    if (viewId) {
      this.views.delete(viewId);
      this.viewToContainerMapping.delete(viewId);
    }
  }

  buildThumbnailContainerId(outputName: string) {
    return `thumbnail-${outputName}`;
  }

  buildMainContainerId(outputName: string) {
    return `main-${outputName}`;
  }
}
